import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Paginator.scss";

function Paginator({
  totalItems,
  page,
  pageSize,
  setPageSize,
  showSizeSelector = true,
  showPagesText = true,
  onPageChange,
}) {
  const { t } = useTranslation();
  const [sizes] = useState([10, 20, 50, 100]);
  const numberTotalPages = totalItems === 0 ? 1 : Math.ceil(totalItems / pageSize);
  const totalPagesToShow = 3;
  const pages = [];

  //#region Functions
  function resetPageIfOverflow() {
    if (numberTotalPages < page) {
      onPageChange(1);
    }
  }

  function generatePageNumbers() {
    if (numberTotalPages <= totalPagesToShow) {
      for (let i = 1; i <= numberTotalPages; i++) {
        pages.push(i);
      }
    } else {
      if (page <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
      } else if (page >= numberTotalPages - 2) {
        for (let i = numberTotalPages - 3; i <= numberTotalPages; i++) {
          pages.push(i);
        }
      } else {
        for (let i = page - 2; i <= page + 2; i++) {
          pages.push(i);
        }
      }
    }
  }

  //#region

  //#region Handlers
  function handlePageChange(newPage) {
    onPageChange(newPage);
  }

  //#region

  resetPageIfOverflow();
  generatePageNumbers();

  return (
    <div className="paginator">
      <div className="left-wrapper">
        <div className="btns-wrapper">
          <div className="pages-btn">
            <div
              className={`pages-arrow ${page === 1 ? "btn-disable" : ""}`}
              onClick={() => page !== 1 && handlePageChange(1)}
            >
              skip_previous
            </div>
            <div
              className={`pages-arrow ${page === 1 ? "btn-disable" : ""}`}
              onClick={() => page !== 1 && handlePageChange(page - 1)}
            >
              keyboard_arrow_left
            </div>
            <ul className="pages-ul">
              {pages.map((pageNumber) => (
                <li
                  key={`PaginatorIndex${pageNumber}`}
                  className={page === pageNumber
                    ? "page-li active-page"
                    : "page-li no-active-page"}
                  onClick={page === pageNumber
                    ? null
                    : () => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </li>
              ))}
            </ul>
            <div
              className={`pages-arrow ${page === numberTotalPages ? "btn-disable" : ""}`}
              onClick={() => page !== numberTotalPages && handlePageChange(page + 1)}
            >
              keyboard_arrow_right
            </div>
            <div
              className={`pages-arrow ${page === numberTotalPages ? "btn-disable" : ""}`}
              onClick={() => page !== numberTotalPages && handlePageChange(numberTotalPages)}
            >
              skip_next
            </div>
          </div>
        </div>
      </div>
      <div className="right-wrapper">
        {showSizeSelector && (
          <div className="size-selector-wrapper">
            {sizes.map((s) => (
              <div
                key={"available-size-" + s}
                className={s === pageSize ? "size active" : "size"}
                onClick={() => setPageSize(s)}
              >
                {s}
              </div>
            ))}
          </div>
        )}
        {showPagesText && (
          <div className="items-count">
            {`${page ? page : 1} ${t("PaginatorOf")} ${isNaN(numberTotalPages) ? 1 : numberTotalPages} ${t("PaginatorPages")} (${totalItems ? totalItems : 0}  ${t(
              "PaginatorTotal"
            )})`}
          </div>
        )}
      </div>
    </div>
  );
}

export default Paginator;
